export function CargoIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" {...props}>
      {/* box back */}
      <rect x="8" y="12" width="24" height="24" rx="2" fill="#F59E0B" opacity="0.15" />
      <rect x="8" y="12" width="24" height="24" rx="2" stroke="#F59E0B" strokeWidth="2.5" />
      {/* box top flaps */}
      <path d="M8 12l4-6h16l4 6" fill="#F59E0B" opacity="0.1" />
      <path d="M8 12l4-6h16l4 6" stroke="#F59E0B" strokeWidth="2.5" strokeLinejoin="round" />
      {/* center seam */}
      <line x1="20" y1="12" x2="20" y2="6" stroke="#F59E0B" strokeWidth="1.5" opacity="0.5" />
      {/* tape / label */}
      <rect x="15" y="20" width="10" height="8" rx="1" fill="#F59E0B" opacity="0.35" />
      {/* arrows on label */}
      <path
        d="M20 22v4M18 23.5l2-1.5 2 1.5"
        stroke="#F59E0B"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
